import React, { RefObject, useEffect } from 'react';

import { ActiveModel } from "../components/CustomLabelsGroup/components/CustomLabelsGroupConfigurePriority";

type TOnClickOutside = (event: MouseEvent) => void;
type useOnClickOutsideProps<T> = {
  onClickOutside: TOnClickOutside;
  anchors?: RefObject<T>[];
  ignore?: boolean;
  setActiveModal?: React.Dispatch<React.SetStateAction<ActiveModel | null>>;
};

function useOnClickOutside<T extends HTMLElement = HTMLElement>({
  anchors,
  onClickOutside,
  setActiveModal,
  ignore,

}: useOnClickOutsideProps<T>): void {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (anchors && anchors.length > 0) {
        const target = event.target as HTMLElement;
        for (const clickedRef of anchors) {
          if (!clickedRef?.current || clickedRef.current.contains(target)) {
            return;
          }
        }

        if (target.closest('.aml-risk-settings__model__priority')) return;
      }

      onClickOutside(event);
    };

    const wrappedHandler = (event: MouseEvent) => {
      if (ignore) return;
      setTimeout(() => handleClickOutside(event), 300);
      if (setActiveModal) {
        setActiveModal(null);
      }
    };

    document.addEventListener('click', wrappedHandler, true);
    return () => {
      document.removeEventListener('click', wrappedHandler, true);
    };
  }, [anchors, onClickOutside, ignore]);
}

export default useOnClickOutside;
